
import { Component, Emit, Vue } from 'vue-property-decorator'
import lodash from 'lodash'

@Component({})
export default class ExchangeTabsComp extends Vue {
  tabPane: Array<{
    key: number
    title: string
  }> = [
    { key: 0, title: '全部' },
    { key: 1, title: '福利券' },
    { key: 2, title: '文房券' }
    // { key: 3, title: '伴学卡' }
  ]
  defaultActiveKey: number = 0
  activeKey: number = +lodash.get(this.$route.query, 'active', this.defaultActiveKey)

  @Emit('change')
  tabsChange(activeKey: string) {
    if (this.activeKey === +activeKey) return

    this.activeKey = +activeKey

    return this.activeKey
  }
}
